(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chem-contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-chem-wa-form]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var phone = form.getAttribute('data-phone');
      var nombre = form.querySelector('input[name="nombre"]').value || '';
      var tramite = form.querySelector('select[name="tramite"]').value || '';
      var msg = 'Hola CHEM, soy ' + nombre + '. Me interesa: ' + tramite + '.';
      var url = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
      window.open(url, '_blank');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chem-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-chem-header]').forEach(function(header){
    var btn = header.querySelector('[data-chem-menu-btn]');
    var menu = header.querySelector('[data-chem-menu]');
    if(!btn || !menu) return;
    btn.addEventListener('click', function(){
      var open = menu.classList.toggle('chem-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    menu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        menu.classList.remove('chem-open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
